import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferConfigurePageContainer as CampaignComponentConfigurePageContainer } from '@occc-app/offerHelpers/components/OfferConfigurePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { getCreatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';

import { OfferConfigureFormContainer } from '../components/OfferConfigureForm/OfferConfigureFormContainer';
import { messages } from '../messages';

export const OfferConfigurePageContainer: React.FC = () => {
  const { id: campaignId = '', offerId = '' } = useParams<{ id: string; offerId: string }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);

  return (
    <CampaignComponentConfigurePageContainer
      campaignId={campaignId}
      offerId={offerId}
      getBreadcrumbLinks={(offerName) => getCreatePageLinks(campaignId, campaignName, offerName)}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Offer}
      ConfigureFormContainer={OfferConfigureFormContainer}
    />
  );
};
